'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericError = void 0;
var tslib_1 = require("tslib");
/**
 * Базовый класс ошибки. Должен использоватья для создания типизированных ошибок.
 *
 * @export
 * @class GenericError
 * @extends {Error}
 */
var GenericError = /** @class */ (function (_super) {
    tslib_1.__extends(GenericError, _super);
    function GenericError(_a) {
        var message = _a.message, type = _a.type, domain = _a.domain, details = _a.details;
        var _this = _super.call(this, message) || this;
        _this.details = {};
        Object.setPrototypeOf(_this, GenericError.prototype);
        _this.type = type;
        _this.domain = domain;
        _this.name = type;
        if (details) {
            _this.details = details;
        }
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, GenericError);
        }
        else {
            _this.stack = new Error().stack;
        }
        return _this;
    }
    /**
     * Печать детализации ошибки.
     * Внутри происходит сриализация details.
     *
     * @returns string детали ошибки в виде строки
     * @memberof GenericError
     */
    GenericError.prototype.printDetails = function () {
        return JSON.stringify(this.details, null, 2);
    };
    /**
     * Конвертация ошибки в данные.
     * Метод может быть полезен при пробрасывании информации от ошибок более низкого уровня в высокоуровневые ошибки
     */
    GenericError.prototype.toJSON = function () {
        return {
            type: this.type,
            domain: this.domain,
            message: this.message,
            details: this.details,
        };
    };
    return GenericError;
}(Error));
exports.GenericError = GenericError;
//# sourceMappingURL=genericError.js.map
